import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { auth0CanActivate, auth0CanMatch } from "src/util/auth0/auth0.guard";
import { StockCooperativeComponent } from "./stock-cooperative/stock-cooperative.component";
import { FunctionalUnitComponent } from "./functional-unit/functional-unit.component";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { CustomerCheckStore } from "src/stores/customer-check.store";
import { inject } from "@angular/core";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";
import { CompanyCheckStore } from "src/stores/company-check.store";
import { ProjectSalesPaceService } from "./services/new-dwelling-project-sales.service";
import { NewDwellingDataService } from "./services/new-dwelling-data.service";

export const demoModeGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const customerCheckStore = inject(CustomerCheckStore);
  const companyCheckStore = inject(CompanyCheckStore);
  const authService = inject(EvAuthorizationService);
  const hasDebugPermission = authService.hasPermission(EVServiceType.Internal_Debug, false, false);
  if (!hasDebugPermission) {
    return true;
  }
  if (route.queryParams['demoMode'] === 'enabled' && (!customerCheckStore.demoMode() || !companyCheckStore.demoMode())) {
    customerCheckStore.enableDemoMode();
    companyCheckStore.enableDemoMode();
  }
  return true;
}

export const INFOPAGE_ROUTES = [
    {
        path: "customer/:personGuid",
        redirectTo: 'customercheck/:personGuid'
    },
    {
        path: "customer/:personGuid/equity-check",
        redirectTo: 'customercheck/:personGuid/equity-check'
    },
    {
        path: "customercheck/:personGuid",
        loadComponent: () => import("./customer-check/customer-infopage.component").then((c) => c.CustomerInfoPageComponent),
        loadChildren: () => import("./customer-check/customer-check.routes").then((m) => m.CUSTOMER_CHECK_ROUTES),
        canMatch: [auth0CanMatch],
        canActivate: [auth0CanActivate, demoModeGuard],
        data: { routePermissions: [EVServiceType.EvWeb_CustomerCheck] },
    },
    {
        path: "customercheck/:personGuid/equity-check",
        loadComponent: () => import("./customer-check/components/equity-check/equity-check.component").then((c) => c.EquityCheckComponent),
        canMatch: [auth0CanMatch],
        canActivate: [auth0CanActivate, demoModeGuard],
        data: { routePermissions: [EVServiceType.EvWeb_CustomerCheckEquityCheck] },
    },
    {
        path: "companycheck/:orgNumber",
        loadComponent: () => import("./company-check/company-infopage.component").then((c) => c.CompanyInfoPageComponent),
        loadChildren: () => import("./company-check/company-check.routes").then((m) => m.COMPANY_CHECK_ROUTES),
        canMatch: [auth0CanMatch],
        canActivate: [auth0CanActivate, demoModeGuard],
        data: { routePermissions: [EVServiceType.EvWeb_CompanyCheck] },
    },
    {
        path: "newdwelling/project",
        loadComponent: () => import("./new-dwelling/new-dwelling-infopage.component").then((c) => c.NewDwellingInfopageComponent),
        loadChildren: () => import("./new-dwelling/new-dwelling.routes").then((m) => m.NEW_DWELLING_ROUTES),
        canMatch: [auth0CanMatch],
        canActivate: [auth0CanActivate],
        data: { routePermissions: [EVServiceType.EvWeb_NewDwellings] },
        providers: [ProjectSalesPaceService, NewDwellingDataService],
    },
    {
        path: "stockcooperative/:unitId",
        component: StockCooperativeComponent,
        canActivate: [auth0CanActivate],
        data: { routePermissions: [EVServiceType.EvWeb_Standard] },
    },
    {
        path: "functionalunit/:unitId",
        component: FunctionalUnitComponent,
        canActivate: [auth0CanActivate],
        data: { routePermissions: [EVServiceType.EvWeb_Standard] },
    },
];
